import React, { useMemo } from "react";
import { isMobile } from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./panorama.css"
import { useMetadata } from "hooks/query";
import { useSection } from "hooks/section";
import { useAddAffilicateRedirect } from "hooks/queries";

function usePanoramaFirstPage() {
    console.log("PANORAMA BEFORE METADATA");
    const metadataQuery = useMetadata();
   
    return useMemo(() => {
        let matches =
            metadataQuery.isSuccess &&
            metadataQuery.data.banners.$values.filter(
                (value) =>                   
                    value.size === "Panorama"
            );  
            console.log("Matches", matches)     
        return matches;
    }, [metadataQuery]);
}

function PanoramaFirstPage() {
    const banners = usePanoramaFirstPage();  

    const settings = {
        dots: false,
        draggable: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 12000,
        slidesToShow: 1,
        slidesToScroll: 1,     
        pauseOnHover: true,
    };   

        return (

            <div className="text-center p-3 mb-5 margin-top" id="panoramaId">
                  <Slider {...settings}> 
                  {banners &&
                            banners.map((value) => {
                                return <a className="panoramadiv panorama_analytics" href={value.homePage}>{isMobile? (
                               <img className="img-fluid" src={value.smallUrl} loading="lazy" alt="panorama-banner"></img>
                            ) :
                            (
                                <img className="img-fluid" src={value.largeUrl} loading="lazy" alt="panorama-banner"></img>
                            )}</a>;
                            })}
                </Slider> 
               
            </div>
        );  
}

export default PanoramaFirstPage;
